import { makeStyles } from '@mui/styles';
import React from 'react';
import { AppFontFamily } from '../../utils/AppFontFamily';
import { IAppTheme } from '../../utils/AppTheme';
import { PDLTypography } from './PDLTypography';

export interface AppTypographyProps {
  id?: string;
  type: PDLTypography;
  customClasses?: string;
  customStyles?: React.CSSProperties;
  onClick?: () => void;
}

const useStyles = makeStyles<IAppTheme, {}, PDLTypography>((theme) => ({
  largeHeading: {
    fontFamily: AppFontFamily.SHAPE_BOLD,
    fontSize: '1.5em',
    lineHeight: '120%',
    color: '#01000E',
    fontWeight: '700',
  },
  mediumHeading: {
    fontFamily: AppFontFamily.SHAPE_BOLD,
    fontSize: '1.2em',
    lineHeight: '120%',
    color: '#01000E',
    fontWeight: '700',
  },
  smallHeading: {
    fontFamily: AppFontFamily.SHAPE_BOLD,
    fontSize: '1em',
    lineHeight: '120%',
    color: '#01000E',
    fontWeight: '700',
  },
  subHeading: {
    fontFamily: AppFontFamily.SHAPE_BOLD,
    fontSize: '0.8em',
    lineHeight: '120%',
    color: '#01000E',
    fontWeight: '700',
  },
  subHeadingSerif: {
    fontFamily: AppFontFamily.FREIGHT_TEXT_PRO_ITALIC,
    fontSize: '0.9em',
    lineHeight: '120%',
    color: '#01000E',
    fontWeight: '400',
    textAlign: 'center',
  },
  paragraph: {
    fontFamily: AppFontFamily.SHAPE,
    fontSize: '1em',
    lineHeight: '140%',
    color: '#01000E',
    fontWeight: '400',
  },
  smallParagraph: {
    fontFamily: AppFontFamily.SHAPE,
    fontSize: '0.8em',
    lineHeight: '140%',
    color: '#01000E',
    fontWeight: '400',
  },
  callToAction: {
    fontFamily: AppFontFamily.SHAPE_BOLD,
    fontSize: '1em',
    lineHeight: '140%',
    color: '#2238CB',
    fontWeight: '700',
  },
  labelsSmallSerif: {
    fontFamily: AppFontFamily.FREIGHT_TEXT_PRO_ITALIC,
    fontWeight: 400,
    fontSize: '0.87em',
  },

  // Portal
  portalLargeHeading: {
    fontFamily: AppFontFamily.SHAPE_BOLD,
    fontSize: '1.5em',
    lineHeight: '120%',
    color: '#01000E',
    fontWeight: '700',
  },
  portalSmallHeading: {
    fontFamily: AppFontFamily.SHAPE_BOLD,
    fontSize: '1em',
    lineHeight: '120%',
    color: '#01000E',
    fontWeight: '700',
  },
  portalItem: {
    fontFamily: AppFontFamily.INTER,
    fontSize: '0.85em',
    lineHeight: '120%',
    color: '#01000E',
    fontWeight: '700',
  },
  portalDrawerItem: {
    fontFamily: AppFontFamily.SHAPE,
    fontSize: '1em',
    lineHeight: '100%',
    color: '#FFFFFF',
    fontWeight: '400',
  },
  portalLabel: {
    fontFamily: AppFontFamily.INTER,
    fontSize: '0.80em',
    lineHeight: '120%',
    color: '#01000E',
    fontWeight: '600',
    opacity: 0.5,
  },
  portalHeader: {
    fontFamily: AppFontFamily.SHAPE_BOLD,
    fontSize: '1.75em',
    lineHeight: '120%',
    color: '#01000E',
    fontWeight: '600',
  },
  none: {},
}));

export const AppTypography: React.FunctionComponent<AppTypographyProps> = (props) => {
  const { id, customClasses, customStyles } = props;
  const appClasses = useStyles();

  return (
    <span
      id={id}
      className={`${appClasses[props.type]} ${customClasses ? customClasses : ''}`}
      style={customStyles}
      onClick={props.onClick}
    >
      {props.children}
    </span>
  );
};
